import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {orders as ordersAction} from 'actions'
import useUserLoginStatus from './useUserLoginStatus'
import useOpenFutureStatus from './useOpenFutureStatus'

function useOpenOrdersDataProvider (symbol) {
  const dispatch = useDispatch()
  const isLogin = useUserLoginStatus()
  const ifOpenFuture = useOpenFutureStatus()
  const fetchData = useCallback(async () => {
    if (!isLogin) return
    const {openOrders} = await ApiSdk.futures.getOpenOrders({symbol}, true)
    if (openOrders) dispatch(ordersAction({openOrders}))
  }, [dispatch, isLogin, symbol])

  useEffect(() => {
    if (isLogin && ifOpenFuture) {
      fetchData()
    }
  }, [dispatch, fetchData, isLogin, ifOpenFuture, symbol])
}

export default useOpenOrdersDataProvider
